export enum StartType {
  TRANSPORT_COMPANY = 0,
  SCHOOL = 1,
  ADDRESS = 2
}
